// Internal Dependencies:
import { doRequest } from 'utilities/request'
import { get } from 'utilities/objects'

export function receiveTickets( data ) {
	return {
		type: 'RECEIVE_TICKETS',
		payload: data
	}
}

export function getTickets( args = {} ) {
	const {
		currentPage = 1,
		perPage = 10,
		filter = '',
		orderBy = '',
		order = '',
		search = ''
	} = args

	return function( dispatch, getState ) {
		let url = `${siteData.api_base_url}tickets?page=${currentPage}&per_page=${perPage}&filter=${filter}&order_by=${orderBy}&order=${order}&search=${search}`

		return doRequest( url, {
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true
		} )
			.then( json => {
				dispatch( receiveTickets( json ) )
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function receiveTicketMessage( userID, userName, ticketId, message ) {
	return {
		type: 'RECEIVE_TICKET_MESSAGE',
		payload: {
			userID,
			userName,
			ticketId,
			message
		}
	}
}

export function sendMessage( ticketId, message, markAsResolved, sendReplyToRetailer ) {
	return function( dispatch, getState ) {
		// const customerEmail = get( ['accountData', 'email'] )( getState().user )
		const userID = get( ['accountData', 'user_id'] )( getState().user )
		const userName = get( ['accountData', 'name'] )( getState().user )

		dispatch( receiveTicketMessage( userID, userName, ticketId, message ) )

		return doRequest( `${siteData.api_base_url}ticket-message`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				ticket_id: ticketId,
				user_id: userID,
				message,
				send_reply_to_retailer: sendReplyToRetailer,
				mark_as_resolved: markAsResolved
			}
		} )
			.then( json => {
				if ( markAsResolved ) {
					dispatch( closeTicketDo( ticketId ) )
				}
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function setTicketMessagesAsSeen( ticketId ) {
	return function( dispatch, getState ) {
		return doRequest( `${siteData.api_base_url}seen-ticket-messages`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				ticket_id: ticketId
			}
		} )
			.then( json => {

			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function closeTicket( ticketId ) {
	return function( dispatch, getState ) {
		dispatch( closeTicketDo( ticketId ) )

		return doRequest( `${siteData.api_base_url}close-ticket`, {
			method: 'DELETE',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				ticket_id: ticketId
			}
		} )
			.then( json => {

			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function closeTicketDo( ticketId ) {
	return {
		type: 'CLOSE_TICKET',
		payload: ticketId
	}
}

export function saveInteralNotes( ticketId, notes, files = [] ) {
	return function( dispatch, getState ) {
		const userID = get( ['accountData', 'user_id'] )( getState().user )

		dispatch( loadingInteralNotes() )

		const formData = new FormData()
		formData.append( 'ticket_id', ticketId )
		formData.append( 'user_id', userID )
		formData.append( 'notes', notes )

		if ( files && files.length ) {
			files.map( ( file, key ) => {
				formData.append( 'files[]', file, file.name )
			} )
		}

		return doRequest( `${siteData.api_base_url}internal-notes`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: formData
		} )
			.then( json => {
				dispatch( receiveInteralNotes( ticketId, json ) )
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function deleteInternalNoteAttachment( ticketId, attachmentId ) {
	return function( dispatch, getState ) {
		const userID = get( ['accountData', 'user_id'] )( getState().user )

		dispatch( loadingInteralNotes() )

		return doRequest( `${siteData.api_base_url}internal-notes-attachment`, {
			method: 'DELETE',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				ticket_id: ticketId,
				user_id: userID,
				attachment_id: attachmentId
			}
		} )
			.then( json => {
				dispatch( receiveInteralNotes( ticketId, json ) )
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function loadingInteralNotes() {
	return {
		type: 'LOADING_INTERAL_NOTES'
	}
}

export function receiveInteralNotes( ticketId, data ) {
	return {
		type: 'RECEIVE_INTERAL_NOTES',
		payload: {
			ticketId,
			data
		}
	}
}

export function savePublicAttachments( ticketId, files = [], callback ) {
	return function( dispatch, getState ) {
		const userID = get( ['accountData', 'user_id'] )( getState().user )

		dispatch( loadingPublicAttachments() )

		const formData = new FormData()
		formData.append( 'ticket_id', ticketId )
		formData.append( 'user_id', userID )

		if ( files && files.length ) {
			files.map( ( file, key ) => {
				formData.append( 'files[]', file, file.name )
			} )
		}

		return doRequest( `${siteData.api_base_url}public-attachments`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: formData
		} )
			.then( json => {
				dispatch( receivePublicAttachments( ticketId, json ) )
				callback()
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function deletePublicAttachment( ticketId, attachmentId ) {
	return function( dispatch, getState ) {
		const userID = get( ['accountData', 'user_id'] )( getState().user )

		dispatch( deletingPublicAttachment( attachmentId ) )

		return doRequest( `${siteData.api_base_url}public-attachment`, {
			method: 'DELETE',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				ticket_id: ticketId,
				user_id: userID,
				attachment_id: attachmentId
			}
		} )
			.then( json => {
				dispatch( receivePublicAttachments( ticketId, json ) )
				dispatch( deletingPublicAttachment( false ) )
			} )
			.catch( error => {
				console.error( error, 'error' )
			} )
	}
}

export function loadingPublicAttachments() {
	return {
		type: 'LOADING_PUBLIC_ATTACHMENTS'
	}
}

export function deletingPublicAttachment( attachmentId ) {
	return {
		type: 'DELETING_PUBLIC_ATTACHMENT',
		payload: attachmentId
	}
}

export function receivePublicAttachments( ticketId, data ) {
	return {
		type: 'RECEIVE_PUBLIC_ATTACHMENTS',
		payload: {
			ticketId,
			data
		}
	}
}
